export const maxSearchResults = 1000;
export const aboveMaxSearchResultsLabel = '999+';
